/**
 * 竞价场次维护
 */
import React from 'react';

import { Input, Row, Col, Icon, Tooltip, Button, Select, DatePicker, Modal } from 'antd';

import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import server from '../../../axios/server';


//引入消息提示相关组件
import messager from '../../ui/messager';
//竞价场次维护
import AuctionSessionEdit from './AuctionSessionEdit';
//竞价场次详情
import AuctionSessionDetail from './AuctionSessionDetail';
import Loading from '../../ui/Loading';
import OrgSelect from '../../ui/OrgSelect';
import { global_data } from '../../ui/auth';

class AuctionSessionIndex extends React.Component {
    columns = [{
        title: '所属市场',
        dataIndex: 'orgName',
        width: '10%',
    }, {
        title: '场次名称',
        dataIndex: 'name',
        width: '10%',
    }, {
        title: '开始时间',
        dataIndex: 'startTime',
        width: '10%',
    }, {
        title: '结束时间',
        dataIndex: 'endTime',
        width: '10%',
    }, {
        title: '开始展示时间',
        dataIndex: 'startShowTime',
        width: '10%',
    }, {
        title: '场次状态',
        dataIndex: 'status',
        width: '10%',
        format: { 0: '未开始', 1: '进行中', 2: '已结束' }
    }, {
        title: '激活状态',
        dataIndex: 'state',
        width: '10%',
        format: { 0: '激活', 1: '删除', 2: '停止' }
    }    
    , {
        title: '操作',
        dataIndex: 'id',
        width: '15%',
        render: (text, record, index) => (
            <div>
                {       
                    record.status === 0 ?
                        <span>
                            {/* 未通知或未激活才能修改 */}
                            {global_data.authCode.includes("AUCTION_SESSION_EDIT_ADMIN")&&(record.notice === 0 || record.state !== 0) ? 
                            <Tooltip title="修改">
                                <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                            </Tooltip> 
                            : ""}
                            {record.state === 0 ?
                                ( global_data.authCode.includes("AUCTION_SESSION_EDIT_ADMIN") ?
                                <Tooltip title="停止">
                                    <Icon type="stop" theme="filled" className="table-operate-icon" onClick={this.disable.bind(this, text)} />
                                </Tooltip> 
                                : "")
                                :
                                (global_data.authCode.includes("AUCTION_SESSION_EDIT_ADMIN")?
                                <Tooltip title="激活">
                                    <Icon type="check-circle" theme="filled" className="table-operate-icon" onClick={this.enable.bind(this, text)} />
                                </Tooltip>
                                :"")
                            }
                            {record.notice === 0 && record.state === 0 &&global_data.authCode.includes("AUCTION_SESSION_EDIT_ADMIN") ?
                                <Tooltip title="通知商户">
                                    <Icon type="wechat" theme="filled" className="table-operate-icon" style={{color: "green"}} onClick={this.notice.bind(this, text)} />
                                </Tooltip> : ""}
                        </span> : ""
                }
                {
                    record.token != null && record.token !== "" ?
                        <Tooltip title="获取游客旁观竞价场次地址">
                            <Icon type="link" className="table-operate-icon" onClick={this.getVisitorUrl.bind(this, record)} />
                        </Tooltip>
                        : ""
                }
                <Tooltip title="详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
            </div>
        ),
    }];

    state = {
        visible: false,
        editData: {},  //编辑的数据
        loadData: '',
        queryData: {}, //查询数据

        detailVisible: false,

        loadingVisible: false,

        visitorVisible: false,
        visitorUrl: '',
    };

    add = () => {
        this.state.ref.initData({}, []);
        this.setState({
            visible: true,
            editData: {
                "abortiveDuration": '00:03:00', //流拍倒计时默认为“5分钟”
                "increaseDuration": '00:00:59', //加价倒计时默认为“20秒”
                "intervalDuration": 15, //竞价间隔默认5秒
                "state": 0, //默认激活状态
            }
        });
    }

    update = (info, e) => {
        this.setState({ loadingVisible: true });
        //读取竞价品信息
        http.get({
            url: '/auctionSession/getSessionInfo',
            data: { id: info.id },
            success: (res) => {
                let data = { image: res.imageThumbnail, imageUrl: res.image };
                let lotsList = res.lots == null ? [] : res.lots;
                this.state.ref.initData(data, lotsList);
                this.setState({ loadingVisible: false, visible: true, editData: res });
            },
            error: (res) => {
                messager.alert(res, "异常", "error");
                this.setState({ loadingVisible: true });
            }
        });

    }

    //启用
    enable = (info, e) => {
        messager.confirm("是否激活该竞价场次？", () => {
            http.post({
                url: '/auctionSession/enableSession',
                data: { id: info },
                success: (res) => {
                    this.state.loadData(this.queryData);
                    messager.notify("激活成功！");
                }
            });
        });
    }

    //发送微信通知
    notice = (info, e) => {
        messager.confirm("是否发送场次信息通知竞价会员？", () => {
            this.noticeFunc(info);
        });
    }

    noticeFunc = (id) =>{
        http.post({
            url: '/auctionSession/sendMessage',
            data: { id: id },
            success: (res) => {
                this.state.loadData(this.queryData);
                messager.notify("发送成功！");
            }
        });
    }

    //停用
    disable = (info, e) => {
        messager.confirm("是否停止该竞价场次？", () => {
            http.post({
                url: '/auctionSession/disableSession',
                data: { id: info },
                success: (res) => {
                    this.state.loadData(this.queryData);
                    messager.notify("停止成功！");
                }
            });
        });
    }

    //详情
    detail = (info, e) => {
        this.setState({ loadingVisible: true });
        //读取竞价品信息
        http.get({
            url: '/auctionSession/getSessionInfo',
            data: { id: info.id },
            success: (res) => {
                let data = { image: res.imageThumbnail, imageUrl: res.image };
                let lotsList = res.lots == null ? [] : res.lots;
                this.refs["detail"].initData(data, lotsList);
                this.setState({ loadingVisible: false, detailVisible: true, editData: res });
            },
            error: (res) => {
                messager.alert(res, "异常", "error");
                this.setState({ loadingVisible: true });
            }
        });

    }

    /**
     * 获取游客访问路径地址
     * @param {*} info 
     * @param {*} e 
     */
    getVisitorUrl = (info, e) => {
        this.setState({ visitorVisible: true, visitorUrl: server.webServerUrl + '/visitor/auction/' + info.id + "/" + info.token })
    }

    //查询
    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    selectChange = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <OrgSelect style={{ width: '200px' }}
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                                <Input.Search
                                    placeholder="名称"
                                    onSearch={this.inputSearch.bind(this, "name")}
                                    enterButton
                                    style={{ width: '200px', margin: '0 10px' }}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} />
                                <Select defaultValue="" style={{ width: 120, marginLeft: '10px' }} onChange={this.selectChange.bind(this, "status")}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="0">未开始</Select.Option>
                                    <Select.Option value="1">进行中</Select.Option>
                                    <Select.Option value="2">已结束</Select.Option>
                                </Select>
                                {global_data.authCode.includes("AUCTION_SESSION_ADD")?
                                <Button type="primary" onClick={this.add} style={{ float: "right" }}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/auctionSession/findSessionPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <AuctionSessionEdit
                    visible={this.state.visible}
                    onCancel={() => { this.setState({ visible: false }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    onRef={(ref) => { this.setState({ ref: ref }) }}
                    noticeFunc={this.noticeFunc}
                />
                <AuctionSessionDetail
                    visible={this.state.detailVisible}
                    onCancel={() => { this.setState({ detailVisible: false }) }}
                    editData={this.state.editData}
                    ref="detail"
                />
                <Modal
                    width={600}
                    visible={this.state.visitorVisible}
                    title="场次旁观地址"
                    okText="保存"
                    cancelText="取消"
                    maskClosable={false}
                    onCancel={() => { this.setState({ visitorVisible: false }) }}
                    onOk={() => { }}
                    footer={[
                        <Button key="take" type="primary" onClick={() => { this.setState({ visitorVisible: false }) }}>确定</Button>,
                    ]}
                >
                    <span>{this.state.visitorUrl}</span>
                </Modal>
                <Loading visible={this.state.loadingVisible} message="处理中，请稍候..." />
            </div>
        )
    }

}

export default AuctionSessionIndex;